import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGlobe04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m13.894 12.58 2.64 1.132c.13.056.28.12.406.188.14.075.347.202.514.427a1.5 1.5 0 0 1 .294.989c-.018.28-.12.498-.197.639-.069.124-.16.26-.238.378-.49.736-.932 1.754-1.628 2.326a1.5 1.5 0 0 1-.517.276c-.872.265-2.46.313-3.357-.04a1.5 1.5 0 0 1-.601-.433c-.605-.723-.765-1.965-1.054-2.831l-.008-.023a1.89 1.89 0 0 1-.103-.44 1.498 1.498 0 0 1 .034-.469c.147-.635.558-1.299.887-1.849.07-.114.176-.269.346-.406a1.5 1.5 0 0 1 .781-.324c.218-.023.402.01.532.043.426.107.867.245 1.269.418Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM3.506 9.019A9 9 0 1 0 15.23 3.597c-.084 1.245.351 3.211-.693 4.172-1.095 1.008-3.055 1.445-4.393 2.04l-.889 1.184c-.07.093-.153.205-.235.298a1.51 1.51 0 0 1-.457.36 1.5 1.5 0 0 1-.903.14 1.508 1.508 0 0 1-.544-.206 4.897 4.897 0 0 1-.315-.212L3.506 9.019Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgGlobe04.displayName = 'Globe04';
export default SvgGlobe04;
